import { useMemo } from 'react';
import { type YoutubeVideoData } from '@/api/ai/youtube/types';
export const YoutubeIframe = ({
  videoData,
  isPlaying
}: {
  videoData: YoutubeVideoData;
  isPlaying: boolean;
}) => {
  /**
   * YouTube embed URL 생성 (AC-2.3.3)
   * enablejsapi=1: IFrame API 활성화
   * modestbranding=1: YouTube 로고 최소화
   * controls=1: 플레이어 컨트롤 표시
   * autoplay: 플레이어 전환 시에만 자동재생
   */
  const embedUrl = useMemo(() => {
    const baseUrl = 'https://www.youtube.com/embed';
    const params = new URLSearchParams({
      enablejsapi: '1',
      modestbranding: '1',
      controls: '1',
      autoplay: isPlaying ? '1' : '0'
    });
    return `${baseUrl}/${videoData.videoId}?${params.toString()}`;
  }, [videoData.videoId, isPlaying]);
  return <iframe className="h-full w-full" src={embedUrl} title={videoData.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-sentry-component="YoutubeIframe" data-sentry-source-file="YoutubeIframe.tsx" />;
};